<template>
    <div class="app">
        <Navigation />

        <main v-if="!user">
            <login>
                <template v-slot:title>Unverified gear</template>
                <template v-slot:text>Login to save your gear.</template>
            </login>
        </main>

        <main v-if="user">

            <div class="app__title">
                <h1>Unverified gear</h1>

                <button @click="addNewGearModal()" class="button button--icon" v-b-tooltip.hover title="Add gear">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><path d="M12 5v14M5 12h14"/></svg>
                </button>
            </div>

            <section>
                <div class="gear__overview">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-12 m-b-1" v-for="g in gearItems" :key="g.id">
                                <ListItemGear :gearId="g.id"></ListItemGear>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="app__title">
                <h1>Verified gear ({{ gearItemsUniverified.length }})</h1>
            </div>

            <section>
                <div class="gear__overview">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-12 m-b-1" v-for="g in gearItemsUniverified" :key="g.id">
                                <ListItemGear :gearId="g.id"></ListItemGear>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <ModalAddGear v-if="showAddNewGearModal" @close="showAddNewGearModal = false" />

    </div>
</template>

<script>
import Navigation from "@/components/Nav";
import ModalAddGear from "@/components/ModalAddGear";
import { mapState } from 'vuex'
import Login from './Login.vue';
import ListItemGear from "./ListItemGear.vue";

export default {
    data() {
        return {
            query: '',
            showAddNewGearModal: false,
            newGear: { knobs: [] }
        };
    },
    computed: {
        ...mapState(['gear', 'user', 'currentUser']),
        gearItems() {
            var items = this.gear.filter(item => {
                return item.verified === undefined
            })
            return items
        },

        gearItemsUniverified() {
            var items = this.gear.filter(item => {
                return item.verified !== undefined
            })
            items.map((item, index) => {
                if(!item.image) {
                    try {
                        items[index].image =  require('@/assets/gear/'+(item.brand.toLowerCase()+'-'+item.title.toLowerCase()).replaceAll(' ', '-')+'.jpg')
                    } catch (e) {
                        items[index].image = "//placehold.it/400x400"
                    }
                }
            });
            return items
        }
    },
    components: { ModalAddGear, Navigation, Login, ListItemGear },
    methods: {
        addNewGearModal: function() {
            this.showAddNewGearModal = true;
        },

        addKnob: function(){
            this.newGear.knobs.push({
                id: this.$uuid.v4(),
                title: null,
                type: null,
                options: []
            })
        },

        removeKnob: function(index){
            this.newGear.knobs.splice(index, 1)
        },

        addKnobOption: function(index) {
            this.newGear.knobs[index].options.push("");
        },
        removeKnobOption: function(knob,index){
            this.newGear.knobs[knob].options.splice(index, 1)
        },

        addGear: function() {
            this.$store.dispatch('addGear', this.newGear)
            this.newGear = {}
            this.showAddNewGearModal = false
        },

        addMyGear: function(gearId) {
            this.$store.dispatch('addGearUser', gearId)
            this.query = ''
        }
    },
    created() {
    },
    destroyed() {
    },
}
</script>